<!-- ============================================================================= -->
<!-- Ella Custom JS - Customize The Style For Layout -->
<!-- ============================================================================= -->

<!-- ============================================================================= -->
<!-- IMPORTANT DISCLAIMER -->
<!-- Please use only JS to style the layout. -->
<!-- ============================================================================= -->

document.querySelectorAll('.js-trending-keyword').forEach(btn => {
  btn.addEventListener('click', () => {
    const keyword = btn.dataset.keyword;
    const searchInput = document.querySelector('input[name="q"]');
    if(searchInput) {
      searchInput.value = keyword;
      searchInput.focus(); 
    }
  });
});
 